import PropTypes from 'prop-types';
import React__default, { createContext, useContext, useMemo } from 'react';
import { deprecatedComponent } from '../../components/core/deprecated-component.js';
import { renderWithRef } from '../../components/core/render-with-ref.js';

const ExperimentsContext = /*#__PURE__*/ createContext(new Set());
/**
 * @deprecated we are no longer supporting this feature, please remove
 */ function useExperimentsContext(experiment) {
    const experiments = useContext(ExperimentsContext);
    if (experiment === null) return new Set();
    if (experiment) return new Set([
        experiment
    ]);
    return experiments;
}
const propTypes = {
    experiments: PropTypes.arrayOf(PropTypes.string.isRequired),
    extendsParentExperiments: PropTypes.bool
};
/**
 * @deprecated To maintain a high-quality user experience, we are no longer supporting this feature, and are not providing a direct replacement.
 */ const ExperimentsProvider = deprecatedComponent({
    displayName: 'ExperimentsProvider',
    description: 'To maintain a high-quality user experience, we are no longer supporting this feature, and are not providing a direct replacement.',
    root: renderWithRef('ExperimentsProvider', propTypes, (props)=>{
        const { experiments, extendsParentExperiments, children } = props;
        const experimentsFromParent = useExperimentsContext();
        const value = useMemo(()=>{
            const currentExp = new Set(experiments);
            if (extendsParentExperiments) {
                experimentsFromParent.forEach((experiment)=>{
                    currentExp.add(experiment);
                });
            }
            return currentExp;
        }, [
            experiments,
            experimentsFromParent,
            extendsParentExperiments
        ]);
        return /*#__PURE__*/ React__default.createElement(ExperimentsContext.Provider, {
            value: value
        }, children);
    })
});

export { ExperimentsContext, ExperimentsProvider, useExperimentsContext };
